import React, { useCallback } from "react";
import { MockedProvider } from "@apollo/client/testing";
import SendInvitation from "../../components/SendInvitation";
import { SEND_INVITATION } from "../../graphql/invitation";
import VStack from "../../ui_atoms/VStack";
import Headline from "../../components/Headline";
import { GET_WORKER_INFO } from "../../graphql/core";
import { ScrollView } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";
import { action } from "@storybook/addon-actions";

const mocks = [
    {
        request: {
            query: SEND_INVITATION,
        },
        variableMatcher: () => true,
        result: () => ({
            data: {
                sendInvitation: {
                    token: "fake-token",
                },
            },
        }),
    },
    {
        request: {
            query: GET_WORKER_INFO,
        },
        variableMatcher: () => true,
        newData: () => ({
            data: {
                getWorkerInfo: null, // should return null, if not, it means the user is already in your talent's list
            },
        }),
    },
];

const StoryComponent = () => {
    const onSuccess = useCallback(() => {
        action("success");
    }, []);
    return (
        <MockedProvider mocks={mocks}>
            <VStack gap={0.5} alignment="stretch" style={{ flex: 1, padding: 10 }}>
                <Headline h="2">Send invitation</Headline>
                <SendInvitation setButtonProps={() => {}} onSuccess={onSuccess} />
            </VStack>
        </MockedProvider>
    );
};

const meta = {
    title: "Screens/Send Invitation",
    component: StoryComponent,
    argTypes: {},
    decorators: [
        (StoryFn) => (
            <ScrollView keyboardShouldPersistTaps="handled">
                <StoryFn />
            </ScrollView>
        ),
    ],
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
